// Base styles
import * as staticContained from "assets/components-static-styles/components/button/contained";

const contained = {
  ...staticContained.default,
};

export default contained;
